import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ index, overline, title, copy, center = false }) => (
  <div className={center ? "text-center" : "text-left"} data-testid={`section-head-${index}`}>
    <Reveal>
      <p className="font-accent text-xs tracking-[0.35em] uppercase text-volt mb-5">
        {index && <span className="text-silver/50 mr-3">{index}</span>}
        {overline}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#EDEFF2] max-w-3xl mx-auto-0">
        {title}
      </h2>
    </Reveal>
    {copy && (
      <Reveal delay={0.16}>
        <p className={`mt-6 text-silver/80 text-base md:text-lg leading-relaxed max-w-xl ${center ? "mx-auto" : ""}`}>
          {copy}
        </p>
      </Reveal>
    )}
  </div>
);
